import Tippy from '@tippyjs/react';

import {
  DEFAULT_RECURRING_CHARGE_CONFIG,
  RECURRING_CHARGE_DURATIONS,
  RECURRING_CHARGE_FREQUENCIES
} from 'lib/constants/healthcareProgram/paymentSetup';
import { inRn } from 'lib/helpers/utility';

import Badge from 'components/shared/Badge/Badge';
import Checkbox from 'components/shared/Checkbox/Checkbox';
import Icon from 'components/shared/Icon/Icon';
import Input from 'components/shared/Input/Input';
import Select from 'components/shared/Select/Select';
import Switch from 'components/shared/Switch/Switch';
import Typography from 'components/shared/Typography/Typography';

const RecurringChargeConfig = ({ config = DEFAULT_RECURRING_CHARGE_CONFIG, onChange }) => {
  const update = (patch) => onChange({ ...config, ...patch });

  const durationOption =
    RECURRING_CHARGE_DURATIONS.find((o) => o.value === config.duration_months) ?? null;

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center gap-2">
        <div className="flex items-center gap-0.5">
          <div className="flex items-center gap-1.5">
            <Switch
              checked={!!config.require_approval}
              onChange={(next) => update({ require_approval: next })}
            />
            <Typography variant="p" size="small" color="neutral-800">
              Require practice approval before payment plan acceptance
            </Typography>
          </div>
          <Tippy
            content="This notifies the patient that the request is pending approval and that terms may be altered by the practice."
            placement="top"
            className="tippy-dark">
            <div className="flex h-[22px] w-[22px] items-center justify-center rounded hover:bg-neutral-100">
              <Icon icon="info-circle-mono" size={16} />
            </div>
          </Tippy>
        </div>
        <Badge text="Recommended" variant="lighter" color="primary" />
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <Typography variant="p" size="small" color="neutral-800">
          Up to
        </Typography>
        <div className="max-w-[232px] flex-1">
          <Input
            id="recurring-charge-amount"
            type="number"
            min={1}
            value={config.amount}
            onChange={(e) => update({ amount: inRn(e.target.value) })}
            units={RECURRING_CHARGE_FREQUENCIES}
            currentUnit={config.frequency}
            onUnitChange={(value) => update({ frequency: value })}
            headerClassName="hidden"
          />
        </div>
        <Typography variant="p" size="small" color="neutral-800">
          for up to
        </Typography>
        <div className="max-w-[120px] flex-1">
          <Select
            options={RECURRING_CHARGE_DURATIONS}
            value={durationOption}
            onChange={(opt) => update({ duration_months: opt?.value })}
            isClearable={false}
            menuPortalTarget={document.body}
          />
        </div>
      </div>
      <Checkbox
        id="recurring-charge-offer-on-kiosk"
        label="Offer on GFE Patient Option Letter for patient check-in on kiosk"
        isChecked={!!config.offer_on_kiosk}
        onChange={(e) => update({ offer_on_kiosk: e.target.checked })}
      />
    </div>
  );
};

export default RecurringChargeConfig;
